import { greyTheme } from "@foodpilot/foods";
import { ThemeOptions } from "@mui/material";

const before = {
    "number-small": {
        fontStyle: "normal",
        fontWeight: 700,
        fontSize: "0.875rem",
        lineHeight: "1.4rem",
        color: greyTheme[2800],
    },
    "number-micro": {
        fontStyle: "normal",
        fontWeight: 700,
        fontSize: "0.625rem",
        lineHeight: "1rem",
        color: greyTheme[2800],
    },
    "small-bold": {
        fontStyle: "normal",
        fontWeight: 600,
        fontSize: "0.625rem",
        lineHeight: "1.125rem",
        color: greyTheme[2800],
    },
    "small-medium": {
        fontStyle: "normal",
        fontWeight: 500,
        fontSize: "0.625rem",
        lineHeight: "1.125rem",
        color: greyTheme[2800],
    },
    small: {
        fontStyle: "normal",
        fontWeight: 400,
        fontSize: "0.625rem",
        lineHeight: "1.125rem",
        color: greyTheme[2800],
    },
    "body-bold": {
        fontStyle: "normal",
        fontWeight: "600",
        fontSize: "0.75rem",
        lineHeight: "1.35rem",
        color: greyTheme[2800],
    },
    "body-medium": {
        fontStyle: "normal",
        fontWeight: "500",
        fontSize: "0.75rem",
        lineHeight: "1.35rem",
        color: greyTheme[2800],
    },
    body: {
        fontStyle: "normal",
        fontWeight: "400",
        fontSize: "0.75rem",
        lineHeight: "1.35rem",
        color: greyTheme[2800],
    },
    "big-bold": {
        fontStyle: "normal",
        fontWeight: "600",
        fontSize: "0.875rem",
        lineHeight: "1.575rem",
        color: greyTheme[2800],
    },
    "big-medium": {
        fontStyle: "normal",
        fontWeight: "500",
        fontSize: "0.875rem",
        lineHeight: "1.575rem",
        color: greyTheme[2800],
    },
    big: {
        fontStyle: "normal",
        fontWeight: "400",
        fontSize: "0.875rem",
        lineHeight: "1.575rem",
        color: greyTheme[2800],
    },
    h4: {
        fontStyle: "normal",
        fontWeight: "700",
        fontSize: "0.875rem",
        lineHeight: "1.4rem",
        color: greyTheme[2800],
    },
    h5: {
        fontStyle: "normal",
        fontWeight: "700",
        fontSize: "0.75rem",
        lineHeight: "1.2rem",
        color: greyTheme[2800],
    },
    h6: {
        fontStyle: "normal",
        fontWeight: "700",
        fontSize: "0.625rem",
        lineHeight: "1rem",
        color: greyTheme[2800],
    },
} as const;

const after = {
    "number-small": {
        fontStyle: "normal",
        fontWeight: 700,
        // fontSize: "0.875rem",
        fontSize: "16px",
        lineHeight: "1.4rem",
        color: greyTheme[2800],
    },
    "number-micro": {
        fontStyle: "normal",
        fontWeight: 700,
        // fontSize: "0.625rem",
        fontSize: "14px",
        lineHeight: "1rem",
        color: greyTheme[2800],
    },
    "small-bold": {
        fontStyle: "normal",
        fontWeight: 600,
        // fontSize: "0.625rem",
        fontSize: "12px",
        lineHeight: "1.125rem",
        color: greyTheme[2800],
    },
    "small-medium": {
        fontStyle: "normal",
        fontWeight: 500,
        // fontSize: "0.625rem",
        fontSize: "12px",
        lineHeight: "1.125rem",
        color: greyTheme[2800],
    },
    small: {
        fontStyle: "normal",
        fontWeight: 400,
        // fontSize: "0.625rem",
        fontSize: "12px",
        lineHeight: "1.125rem",
        color: greyTheme[2800],
    },
    "body-bold": {
        fontStyle: "normal",
        fontWeight: "600",
        // fontSize: "0.75rem",
        fontSize: "14px",
        lineHeight: "1.35rem",
        color: greyTheme[2800],
    },
    "body-medium": {
        fontStyle: "normal",
        fontWeight: "500",
        // fontSize: "0.75rem",
        fontSize: "14px",
        lineHeight: "1.35rem",
        color: greyTheme[2800],
    },
    body: {
        fontStyle: "normal",
        fontWeight: "400",
        // fontSize: "0.75rem",
        fontSize: "14px",
        lineHeight: "1.35rem",
        color: greyTheme[2800],
    },
    "big-bold": {
        fontStyle: "normal",
        fontWeight: "600",
        // fontSize: "0.875rem",
        fontSize: "16px",
        lineHeight: "1.575rem",
        color: greyTheme[2800],
    },
    "big-medium": {
        fontStyle: "normal",
        fontWeight: "500",
        // fontSize: "0.875rem",
        fontSize: "16px",
        lineHeight: "1.575rem",
        color: greyTheme[2800],
    },
    big: {
        fontStyle: "normal",
        fontWeight: "400",
        // fontSize: "0.875rem",
        fontSize: "16px",
        lineHeight: "1.575rem",
        color: greyTheme[2800],
    },
    h4: {
        fontStyle: "normal",
        fontWeight: "700",
        // fontSize: "0.875rem",
        fontSize: "16px",
        lineHeight: "1.4rem",
        color: greyTheme[2800],
    },
    h5: {
        fontStyle: "normal",
        fontWeight: "700",
        // fontSize: "0.75rem",
        fontSize: "14px",
        lineHeight: "1.2rem",
        color: greyTheme[2800],
    },
    h6: {
        fontStyle: "normal",
        fontWeight: "700",
        // fontSize: "0.625rem",
        fontSize: "12px",
        lineHeight: "1rem",
        color: greyTheme[2800],
    },
} as const;

const _typographyConfig = {
    fontFamily: ["Montserrat", "serif"].join(","),
    // h1: {
    //     fontStyle: "normal",
    //     fontWeight: "700",
    //     fontSize: "2rem",
    //     lineHeight: "3.2rem",
    //     color: greyTheme[2800],
    // },
    h2: {
        fontStyle: "normal",
        fontWeight: "700",
        fontSize: "1.5rem",
        lineHeight: "2.4rem",
        color: greyTheme[2800],
    },
    h3: {
        fontStyle: "normal",
        fontWeight: "700",
        fontSize: "1.125rem",
        lineHeight: "1.8rem",
        color: greyTheme[2800],
    },
    "huge-bold": {
        fontStyle: "normal",
        fontWeight: 600,
        fontSize: "1.125rem",
        lineHeight: "2.025rem",
        color: greyTheme[2800],
    },
    "huge-medium": {
        fontStyle: "normal",
        fontWeight: 500,
        fontSize: "1.125rem",
        lineHeight: "2.025rem",
        color: greyTheme[2800],
    },
    huge: {
        fontStyle: "normal",
        fontWeight: 400,
        fontSize: "1.125rem",
        lineHeight: "2.025rem",
        color: greyTheme[2800],
    },
    "number-big": {
        fontStyle: "normal",
        fontWeight: 700,
        fontSize: "2rem",
        lineHeight: "3.2rem",
        color: greyTheme[2800],
    },
    "number-inter": {
        fontStyle: "normal",
        fontWeight: 700,
        fontSize: "1.5rem",
        lineHeight: "2.4rem",
        color: greyTheme[2800],
    },
} as const;

type Options = {
    isOverriden?: boolean;
};
export const getThemeOverride = (options?: Options): ThemeOptions => {
    const { isOverriden = false } = options || {};

    if (isOverriden) {
        return {
            /* @ts-expect-error type expects a custom, but we really dont care here */
            custom: {},

            typography: {
                ...after,
                ..._typographyConfig,
            },
        };
    }

    return {
        /* @ts-expect-error type expects a custom, but we really dont care here */
        custom: {},

        typography: {
            ...before,
            ..._typographyConfig,
        },
    };
};
